<template>
  <v-btn
    block
    color="accent"
    large
    depressed
    class="font--m-3 rounded-4"
    height="52"
    :disabled="loading"
    :loading="loading"
    @click="deleteRequest"
  >
    신청 취소하기
  </v-btn>
</template>

<script>
export default {
  props: {
    uuid: {
      Type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async deleteRequest() {
      if (this.loading) {
        return
      }

      let isReloadData = false
      try {
        this.loading = true

        const { isConfirmed } = await this.$swal.basic.confirm({
          html: '신청을 취소하시겠습니까?',
        })
        if (!isConfirmed) {
          return
        }

        isReloadData = true
        const { data: request } = await this.$defaultApi.getCreditPaysRequestDetail(this.uuid)
        if (request.status === 'cancel') {
          await this.$swal.basic.error('이미 취소된 건 입니다.')
          return
        }

        if (request.status !== 'init') {
          await this.$swal.basic.error('신청 상태에서만 취소할 수 있습니다.')
          return
        }

        await this.$defaultApi.cancelCreditPaysRequestDetail(this.uuid)
        await this.$swal.basic.alert('취소가 완료되었습니다.')
      } finally {
        this.loading = false
        if (isReloadData) {
          this.$emit('update')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
